import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';

import { inject } from '@angular/core';
import { ApigeeService } from './apigee.service';
import { throwError } from 'rxjs/internal/observable/throwError';
import { mergeMap } from 'rxjs/operators';
import { from } from 'rxjs/internal/observable/from';
import { SigV4Service } from '../aws/sigv4.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {

  const apigeeService = inject(ApigeeService);
  const sigV4Service = inject(SigV4Service);

  const AWS_AUTHORIZATION_REQUEST_HEADER = "AWSAuthorization";

  let token = apigeeService.apiToken;

  if (!token) {
    apigeeService.logout();
    return throwError("No existe el token");
  }

  if (req.headers.has(AWS_AUTHORIZATION_REQUEST_HEADER)) {
    req = req.clone({
      headers: req.headers.delete(AWS_AUTHORIZATION_REQUEST_HEADER)
    });

    return from(sigV4Service.signRequest(req)).pipe(mergeMap((request: HttpRequest<any>) => next(request)));
  }

  /// Comentado el proceso de refresh token

  // // Token vencido o próximo a vencer
  // if (token && apigeeService.shouldRefresh()) {

  //   return apigeeService.refreshToken().pipe(

  //     switchMap(() => {

  //       const newToken = apigeeService.apiToken;

  //       const authenticatedRequest = addToken(
  //         req,
  //         newToken.access_token
  //       );

  //       return next(authenticatedRequest).pipe(
  //         finalize(() => {
  //           loadManagerService.decLoadRequest();
  //         }));
  //     }),

  //     catchError(error => {
  //       loadManagerService.decLoadRequest();
  //       apigeeService.logout();

  //       return throwError(error);
  //     })
  //   );
  // }

  // Si ya se vencio el token nos deslogueamos
  if (apigeeService.shouldRefresh()) {
    apigeeService.logout();
    return throwError("Token expirado");
  }


  // Token todavía válido
  const authenticatedRequest = addToken(req, token?.access_token);

  return next(authenticatedRequest);
};


/**
 * Agrega el token en la peticion
 * @param req El req de la petición
 * @param token El token
 * @returns  EL request con el token agregado en la cabecera
 */
function addToken(
  req: HttpRequest<unknown>,
  token: string | null
) {

  if (!token) {
    return req;
  }

  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
}
